var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrowIcon = function SvgLeftArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M5.823 8.395a.855.855 0 0 0 0 1.212l5.142 5.143a.856.856 0 1 0 1.212-1.212L7.641 9l4.536-4.537a.856.856 0 1 0-1.212-1.212z"
  })));
};
export default SvgLeftArrowIcon;